// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fx-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
}

.fx-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.fx-container .fx-title {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  min-width: 200px;
}
.fx-container .fx-item {
  margin: 6px;
  font-size: 11px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/under-construct/under-construct.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;AACR;AAEI;EACI,WAAA;EACA,eAAA;AAAR","sourcesContent":[".fx-wrapper {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n}\n\n.fx-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;  \n\n    .fx-title {\n        color: #3E0D42;\n        font-size: 14px;\n        font-weight: bold;\n        letter-spacing: 0.5px;\n        min-width: 200px;\n    }\n\n    .fx-item {\n        margin: 6px;\n        font-size: 11px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
